import { createBrowserRouter, Navigate } from 'react-router-dom';
import { MainLayoutWithTracking } from '../layouts/MainLayoutWithTracking';
import { LoginPage } from '../features/authentication/pages/LoginPage';
import { ProtectedRoute } from './ProtectedRoute';
import { PublicRoute } from './PublicRoute';
import { PublicOnlyRoute } from './PublicOnlyRoute';
import { DynamicRouter } from './DynamicRouter';
import { SurveyResponseRoutes } from '../features/survey-response';
import { PostHogProvider } from '../app/providers/PostHogProvider';
import ErrorBoundary from '../shared/components/ErrorBoundary';
import { LandingLayout } from '../features/landing-page/components/layout';
import {
  HomePage,
  AboutPage,
  DemoPage,
  ContactPage,
  PrivacyPolicyPage,
  TermsOfServicePage,
} from '../features/landing-page/pages';

export const router: ReturnType<typeof createBrowserRouter> = createBrowserRouter([
  // Service Down Page - Shows by default
  {
    path: '/',
    element: (
      <PublicOnlyRoute>
        <LandingLayout />
      </PublicOnlyRoute>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'demo', element: <DemoPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'privacy', element: <PrivacyPolicyPage /> },
      { path: 'terms', element: <TermsOfServicePage /> },
    ],
  },
  // Protected application routes
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <ErrorBoundary>
          <MainLayoutWithTracking />
        </ErrorBoundary>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/app/dashboard" replace />,
      },
      {
        path: '*',
        element: <DynamicRouter />,
      },
    ],
  },
  // Legacy route redirects (for backwards compatibility)
  {
    path: '/dashboard',
    element: <Navigate to="/app/dashboard" replace />,
  },
  {
    path: '/manage/*',
    element: <Navigate to="/app/manage" replace />,
  },
  // Public Survey Response routes (no authentication required)
  {
    path: '/survey/:surveyId/:instanceId/*',
    element: <SurveyResponseRoutes />,
  },
  // Public routes (outside main layout)
  {
    path: '/login',
    element: (
      <PublicRoute>
        <PostHogProvider>
          <LoginPage />
        </PostHogProvider>
      </PublicRoute>
    ),
  },
  // Catch-all route for unmatched paths
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
